import { createSlice } from '@reduxjs/toolkit'
import { fetchAllGamesReport, fetchSlotGameReport, fetchTopPlayerReport } from 'redux-thunk/thunk/reports/gameReports.thunk'

const initialState = {
  allGamesReport: null,
  allGamesGraphReport: null,
  topPlayerReport: null,
  topProfitReport: null,
  allSlotGamesReport: null
}

const gamesReportSlice = createSlice({
  name: 'gamesReportSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllGamesReport.fulfilled, (state, action) => {
        return {
          ...state,
          allGamesReport: action.payload
        }
      })
      .addCase(fetchTopPlayerReport.fulfilled, (state, action) => {
        return {
          ...state,
          topPlayerReport: action.payload
        }
      })
      .addCase(fetchSlotGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          allSlotGamesReport: action.payload
        }
      })
  }
})

export default gamesReportSlice.reducer
